/**
 * ErrorBoundary genérico — evita tela branca em componentes com erro.
 * Uso: <ErrorBoundary label="TicketsOps"><MinhaTela /></ErrorBoundary>
 */
import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log para observabilidade (o console é lido pelos error trackers)
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary${this.props.label ? " " + this.props.label : ""}]`, error, info?.componentStack);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const msg = this.state.error?.message || String(this.state.error || "Erro desconhecido");
      return (
        <div className="min-h-[300px] flex items-center justify-center p-6" data-testid="error-boundary-fallback">
          <div className="max-w-md w-full bg-amber-50 border border-amber-200 rounded-lg p-5 text-center">
            <AlertTriangle className="w-10 h-10 text-amber-600 mx-auto mb-3" />
            <h3 className="text-base font-bold text-amber-900 mb-1">Ocorreu um erro nesta tela</h3>
            <p className="text-xs text-amber-800 mb-4">{msg}</p>
            <div className="flex gap-2 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs bg-amber-600 text-white rounded hover:bg-amber-700"
                data-testid="error-recarregar"
              >
                <RefreshCw className="w-3 h-3" /> Recarregar
              </button>
              <button
                onClick={this.reset}
                className="px-3 py-1.5 text-xs bg-white border border-amber-300 text-amber-800 rounded hover:bg-amber-50"
                data-testid="error-tentar-novamente"
              >
                Tentar novamente
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
